/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentJobDetail {
    getFixupPrototypeFunction() { return ComplianceAssessmentJobDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentJobDetail>): ComplianceAssessmentJobDetail {
        let obj = Object.assign(new ComplianceAssessmentJobDetail(), model);
        ComplianceAssessmentJobDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentJobDetail>): ComplianceAssessmentJobDetail {
        if (!model) return null;
        return ComplianceAssessmentJobDetail.newInstance(<ComplianceAssessmentJobDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentJobDetail) {
        if (!obj) return;

        models.ComplianceAssessmentJobDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentJobDetail): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentJobDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service account ID
     */
    service_account_id: string;

    /**
     * Assessment job number
     */
    assessment_job_number: string;

}
